<template>
  <div class="most-recent">
    <slot :data="dataSource" :filter="onFilter"></slot>
  </div>
</template>

<script>
// import axios from 'axios'

export default {
  name: 'nt-most-recent',
  props: {
    urlApi: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dataSource: {}
    }
  },
  created() {
    this.getData()
  },
  methods: {
    isOutbound(url) {
      try {
        const componentUrl = new URL(url)
        return componentUrl.host.replace('assets.', '') !== window.location.host
      } catch (error) {
        return false
      }
    },
    getData(value) {
      const param = {
        param: value,
        sessionId: this.id
      }

      fetch(this.urlApi, {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(param)
      })
      .then(response => response.json())
      .then((json) => {
        this.dataSource = json
        this.$nextTick(() => {
          const mostRecentCardElements = document.querySelectorAll('.most-recent-tagging')
          if (mostRecentCardElements) {
            mostRecentCardElements.forEach((element, index) => {
              const urlTarget = element.querySelector('.article').getAttribute('href')
              const name = element.querySelector('.title') ? element.querySelector('.title').innerText : ''
              element.addEventListener('click', () => {
                window.dataLayer.push({
                  event: 'click',
                  name,
                  section: 'Most Recent',
                  component_type: 'link',
                  link_url: urlTarget,
                  position: index + 2,
                  outbound: this.isOutbound(urlTarget)
                })
              })
            })
          }
        })
        this.$nextTick(() => {
          const mostRecentArticleHeading = document.querySelector('.article--heading')
          if (mostRecentArticleHeading) {
            const urlTarget = mostRecentArticleHeading.href
            const name = mostRecentArticleHeading.innerText
            mostRecentArticleHeading.addEventListener('click', () => {
              window.dataLayer.push({
                event: 'click',
                name,
                section: 'Principal',
                component_type: 'link',
                link_url: urlTarget,
                position: 1,
                outbound: this.isOutbound(urlTarget)
              })
            })
          }
        })
      })
    },
    onFilter(val) {
      this.getData(val)
      const container = document.querySelector('.article--heading .lazyloaded')
      if (container) {
        container.classList.remove('lazyloaded')
        setTimeout(() => {
          container.classList.add('lazyload')
        }, 500)
      }
    }
  }
}
</script>
